<template>
  <div class="status-box" v-if="usersStatusAPI">
    <template v-for="c in calendarSettings">
      <b-checkbox
        v-if="c.calendar_user === user.user_hash && !isSync"
        :key="c.pk"
        @input="$emit('changeShowEvent', c)"
        v-model="c.is_check"
        :indeterminate="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error'"
        :disabled="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error' || isConfirm">
      </b-checkbox>
    </template>
    <template v-if="isCalendarSettings(user.user_hash)">
      <b-checkbox
        @input="$emit('createCalendarSettings', {
          user: user,
          status: usersStatusAPI.status,
          other:other
        })"
        v-model="other"
        :indeterminate="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error'"
        :disabled="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error' || isConfirm">
      </b-checkbox>
    </template>
    <template v-else-if="selfUser.userHash === user.user_hash">
      <b-checkbox
        v-model="self"
        @input="$emit('changeShowEventSelf', user.user_hash)"
        :indeterminate="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error'"
        :disabled="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error' || isConfirm">
      </b-checkbox>
    </template>
    <Tooltip :message="usersStatusAPI.type">
      <template v-if="usersStatusAPI.status === 'ok'">
        <span style="color: green;" class="mdi mdi-check-circle-outline"></span>
      </template>
      <template v-else-if="usersStatusAPI.status === 'error'">
        <span style="color: red;" class="mdi mdi-comment-alert-outline"></span>
      </template>
      <template v-else>
        <span style="color: black;" class="mdi mdi-checkbox-blank-circle-outline"></span>
      </template>
    </Tooltip>
  </div>
  <div v-else>
    <span class="mdi mdi-loading mdi-spin"></span>
  </div>
</template>

<script>
import Tooltip from '@/components/atoms/tooltips/Tooltip'
export default {
  name: 'CalendarAPIStatus',
  components: {
    Tooltip
  },
  data () {
    return {
      self: this.default != undefined ? this.default : true,
      other: this.defaultOther != undefined ? this.defaultOther : false
    }
  },
  props: {
    user: {
      type: Object,
      require: true
    },
    calendarSettings: {
      type: Array,
      require: true
    },
    selfUser: {
      type: Object,
      require: true
    },
    default: {
      type: Boolean,
      require: false
    },
    usersStatusAPI: {
      type: Object,
      required: true,
    },
    defaultOther: {
      type: Boolean,
      require: false
    },
    isSync: {
      type: Boolean,
      require: false
    },
    isConfirm: {
      type: Boolean,
      require: false,
    },
  },
  methods: {
    isCalendarSettings (userHash) {
      if (this.isSync) return true
      if (this.selfUser.userHash === userHash) return false
      for (const cs of this.calendarSettings) {
        if (cs.calendar_user === userHash) {
          return false
        }
      }
      return true
    },
  }
}
</script>

<style lang='scss' scoped>
.status-box {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Calendar/CalendarAPIStatus.vue